// Je l'ai majoritairement généré avec https://app.quicktype.io/
// C'est quand même bon mais certain modèles pourrons sortir d'ici.

import { InSaleStatus } from "./basesalemodels";
import { EventDateInfo, PromoInfoShort } from "../../mvcapi/models/common";
import { TimeZone } from "./timezone";

export interface PackageInfo {
    PackageID:                      number;
    Name:                           string;
    Description:                    string;
    IsPackageInSale:                boolean;
    IsPackageSoldOut:               boolean;
    IsFixedPackage:                 boolean;
    SalesStartDate:                 string;
    SalesEndDate:                   string;
    LimitQtySales:                  number;
    EventDateMinNumber:             number;
    EventDateMaxNumber:             number;
    MinMandatoryDateRequired:       number;
    MaxMandatoryDateRequired:       number;
    ErrorSellingThisPackage:        boolean;
    ErrorSellingThisPackageMessage: string;
    InSaleStatus:                   InSaleStatus;
    PromoInfo:                      PromoInfoShort;
    EventDateInfos:                 EventDateInfo[];
    MandatoryEventDateInfos:        any[];
    Sections:                       null;
    TimeZone:                       TimeZone;
}
